var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterrogation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.371,
    height: 21.709,
    viewBox: "0 0 10.371 21.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-1084.367 -419.157)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1088.791,434.919a6.847,6.847,0,0,1,.505-2.688,7.628,7.628,0,0,1,1.794-2.278,14.439,14.439,0,0,0,1.846-1.976,5.367,5.367,0,0,0,.769-1.55,6.767,6.767,0,0,0,.242-1.931,4.709,4.709,0,0,0-1.129-3.334,4.031,4.031,0,0,0-3.1-1.214,4.387,4.387,0,0,0-3.317,1.256,4.564,4.564,0,0,0-1.238,3.227h-.791a5.156,5.156,0,0,1,1.537-3.824,5.279,5.279,0,0,1,3.809-1.45,4.787,4.787,0,0,1,3.662,1.45,5.485,5.485,0,0,1,1.363,3.912,6.575,6.575,0,0,1-.66,3,11.437,11.437,0,0,1-2.562,3.039,5.206,5.206,0,0,0-1.934,4.365Zm-.352,5.142a.809.809,0,0,1,.235-.58.767.767,0,0,1,.57-.241.823.823,0,0,1,.82.821.765.765,0,0,1-.241.571.8.8,0,0,1-.579.234.8.8,0,0,1-.805-.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrogation);
export default __webpack_public_path__ + "static/media/interrogation.671999de6b6667e53facc2588e6e8dd0.svg";
export { ForwardRef as ReactComponent };